import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import TermsAndConditionsContent from '../../components/Pages/TermsAndConditions';

const { displayName } = config;

export default function TermsAndConditions(): React.ReactElement {
  document.title = `${displayName}: Terms and Conditions`;

  return (
    <Layout>
      <TermsAndConditionsContent />
    </Layout>
  );
}
